export default "__VITE_ASSET__7a632bc0__"